// formatCurrencyOptionalTwoDigit.ts

export const formatCurrencyOptionalTwoDigit = (value: number | null | undefined): string => {
    if (value == null) return '';

    const hasDecimals = value % 1 !== 0;

    return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
    });
};
